import { Component } from 'react';
import Banner from '../components/common/Banner';

export default class Pricing extends Component {
    render() {
        return (
            <div>
                {/* Page Title */}
                <Banner title={"About Us"} desc={"About Us"} img={"images/bg/bg_2.jpg"} />

                {/* Pricing Section */}
                <section className="section about-page">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-6 text-center">
                                <h2 className="title-color mb-4">Affordable & Transparent</h2>
                                <p>
                                    At Varenya Matrimonial, we believe in transparent and fair pricing to help you start your journey to finding the perfect life partner with ease and confidence.
                                </p>
                            </div>
                        </div>

                        <div className="row justify-content-center mt-5">
                            <div className="col-md-6 col-lg-4">
                                <div className="pricing-box p-5 text-center shadow rounded">
                                    <h4 className="mb-3">One Year Membership (365 Days)</h4>
                                    <p className="text-muted mb-1"><del>₹1200</del></p>
                                    <h2 className="mb-4" style={{ color: "maroon" }}>₹800</h2>
                                    <p>Limited time offer for early members!</p>
                                    <ul className="list-unstyled mt-4 mb-4">
                                        <li>✔ Access to Verified Profiles</li>
                                        <li>✔ Personalized Matchmaking</li>
                                        <li>✔ Brahmin-Only Community</li>
                                    </ul>
                                    <a href="/contact" className="btn btn-main btn-round-full">Register Now</a><br /><br />
                                    <small style={{ fontWeight: "bold" }}>(Call Us we will Register You)</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}
